// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3iLrz","disabled":"FileBtn_disabled__1zhvR","warn":"FileBtn_warn__2Tg86","fade":"FileBtn_fade__2vqbF"};